module.exports = __webpack_public_path__ + "static/img/cont3107.454f684.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3107.jpg
// module id = WTcd
// module chunks = 0